'use strict';

import ShowListPage from './public/ShowListPage.js';
import WatchNowPage from './public/WatchNowPage.js';

var page = new ShowListPage({
  container: '#show-list-page'
});

var watchNow = new WatchNowPage({
  container: '#show-list-page.watch-shows-page'
});

export default {}